import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { alertInfoTypes } from "shared-components/src/components/feedback/alertInfoTypes.enum";
import { showAlertInfo } from "shared-components/src/components/feedback/store/alertInfo.actions";
import {
  hideProgress,
  showProgress,
} from "shared-components/src/components/feedback/store/circularProgress.actions";
import { getApiService } from "../../../services/apiService";
import {
  FORGOT_PASSWORD_REQUEST,
  forgotPasswordFailure,
  forgotPasswordSuccess,
} from "../store/forgotPassword.actions";

const apiService = getApiService();

const forgotPassword = async (data) => {
  const url = `${apiService.getForgotPasswordUrl}`;
  const headers = {
    "Content-Type": "application/json",
  };
  const response = await axios.post(url, data, { headers });
  return response.data;
};

function* handleForgotPassword(action) {
  try {
    yield put(showProgress());
    const response = yield call(forgotPassword, action?.payload);
    yield put(forgotPasswordSuccess(response));
    yield put(hideProgress());
  } catch (error) {
    yield put(
      showAlertInfo({
        type: alertInfoTypes.ERROR,
        message: error?.message,
      }),
    );
    yield put(hideProgress());
    console.log("Forgot password error", error);
    yield put(forgotPasswordFailure(error.message));
  }
}

export function* watchForgotPassword() {
  yield takeLatest(FORGOT_PASSWORD_REQUEST, handleForgotPassword);
}
